<template>
  <div class="thousand_layout">
    <div>
      <div class="bids_tabs">
        <div @click="HistoryTabs(0)" :class="historyTab==0?'on':''">{{ $t('base.unusedCoupons') }}<span class="text_red" v-if="UnusedCount > 0">&nbsp;({{UnusedCount}})</span></div>
        <div @click="HistoryTabs(1)" :class="historyTab==1?'on':''">{{ $t('base.expiredCoupons') }}</div>
      </div>
      <div class="couponsBox" v-if="!nofind">
        <div class="couponsList" v-for="(item,index) in list" :key="index" :class="historyTab == 1? 'overdue':''">
          <div class="couponPrice">
            {{userInfo.MemberSource=='MO'?item.CouponAmountMop:item.CouponAmountUsd}}<br>
            <span>{{ $t('base.off') }} ({{areaSymbol}})</span>
          </div>
          <div class="couponTemplate">
            <div class="couponName">{{item.CouponTemplateName}}</div>
            <div class=""><img src="/static/images/icon/icon_time.svg" style="width: 13px;position: relative;top: 3px;margin-right: 4px;" />{{item.EndTime|setTime}}</div>
          </div>
        </div>
      </div>
      <n-o-t-n class="notfind" title="" :text="$t('base.noData')" type="coupons" v-else-if="resultTpye==1" />
      <f-z-f class="notfind" title="" :text="$t('base.pagefault')" v-else />
    </div>
  </div>
</template>
<script>
import { getTime } from "@/api/public";
import FZF from "@/components/notnull";
import ListPagination from "@/components/listpagination";
import NOTN from "@/components/notnull.vue";

export default {
  name: 'chp',
  components: { FZF, ListPagination, NOTN },
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      historyTab: 0,
      pi: 1,
      ps: 99999,
      list: '',
      nofind: false,
      tabNumber: '',
      Count: 0,
      UnusedCount:0,
      resultTpye: '',
    }
  },
  filters: {
    setTime(val) {
      //console.log(getTime(val, -8, '', 'cn'))
      //return getTime(val, -8, '', 'cn')
      return getTime(val, -8, '', 'cn')
    }
  },
  props: {
    userInfo: {}
  },
  created() {
    this.GetMyCoupon()
  },
  mounted() { },
  methods: {
    HistoryTabs(val) {
      this.historyTab = val;
      this.list = ''
      this.GetMyCoupon();
    },
    //获取优惠券列表
    GetMyCoupon() {
      let that = this;
      let data = { operator_id: this.userInfo.MappingUserId, memberid: this.userInfo.MappingUserId, token: this.userInfo.ChineseToken, pageIndex: this.pi, pageSize: this.ps, isUse: this.historyTab, }
      this.$get(this.$interface.GetCouponByMemberId, data).then(res => {
        if (res.Result != 0) {
          this.list = res.Data;
          //IsUse 是否使用 0未使用 1已经使用 2已过期
          if(this.historyTab==0){
            this.UnusedCount=this.list.length;
          }
          if(that.userInfo.MemberSource=='MO'){
           that.areaSymbol='MOP' 
          }
          //this.TotalCount = res.Count;
          //this.UnusedCount=this.historyTab==0?res.Count:this.UnusedCount;
          this.nofind = false
          if (res.Data.length > 0) {
            this.nofind = false
          } else {
            this.nofind = true
          }
        } else {
          this.nofind = true
        }
        that.resultTpye = res.Result
      })
    },

    // 每页几条
    pageSize(val) {
      this.ps = val
      this.GetMyCoupon();

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      this.GetMyCoupon();
    },

  }
}

</script>
<style scoped>
@import "../../../static/css/usertabslist.css";
.couponsBox {
  display:grid;
  grid-template-columns: 1fr 1fr;
  margin-top: 40px;
  gap: 20px;
}

.couponsList {
  background: #1542D5;
  min-height: 100px;
  border-radius: 10px;
  position: relative;
  display: grid;
  grid-template-columns: 1fr 3fr;
  color: #fff;
  overflow: hidden;
}
.couponsList::before,.couponsList::after{
  content: "";
  width: 12px;
  height: 12px;
  background-color: #fff;
  position: absolute;
  border-radius: 100%;
  top:-6px;
  left: 104px;
}
.couponsList::after{
  top:auto;
  bottom:-6px;
}
.couponPrice{    
    padding: 8px;
    height: 100%;
    border-right:1px dashed #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #406BFA;
    color: #FFD400;
    font-size: 24px;
    line-height: 1.5;
    font-weight: 700;
}
.couponPrice span{
  font-size: 12px;
  font-weight: 400;
}
.couponTemplate{
    padding: 15px 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 12px;
    position: relative;
}
.couponTemplate::before{
  content: '';
  background: url(/static/images/icon/icon_coupon_text.png) no-repeat;    
  background-size: 76%;
  position: absolute;
  height: 44%;
  width: 98%;
  bottom: 0;
  background-position-x: 16px;
}
.couponName{
    font-size: 16px;
    font-weight: 700;
}
.overdue,.overdue .couponPrice{
  background: #C8D4EF;
  color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/pages/user/coupons.vue